<template>
  <patient-pie-analysis
    title="Messenger綁定狀況圓餅圖"
    :data="sourceData"
  />
</template>

<script>
import PatientPieAnalysis from "./PatientPieAnalysis.vue";
import { mapGetters } from "vuex";
import { getAnalysisMessengerAccountAPI } from "../../api";

export default {
  name: "MessengerBindAnalysis",

  components: {PatientPieAnalysis},

  data() {
    return {
      sourceData: null
    }
  },

  computed: {
    ...mapGetters([
      'axiosParamData',
    ]),
  },

  methods: {
    getAnalysisData() {
      getAnalysisMessengerAccountAPI(this.axiosParamData).then(res => {
        const data = res.data
        data.datasets[0].backgroundColor = [
          '#23bfda',
          '#efcf13',
          '#f45d64'
        ]
        this.sourceData = res.data
      })
    }
  },

  mounted() {
    this.getAnalysisData()
  }
}
</script>

<style scoped>

</style>
